import React from "react";
import { Avatar, Box, Divider, List, ListItemAvatar, ListItemButton, ListItemText, Skeleton, Stack, Typography } from "@mui/material";

import { useSearchTermRanks } from "../../hooks/useSearchRanks";
import { useNavigate } from "react-router-dom";
import { Rank } from "@domain/insights/models/Rank";

interface SearchTermRanksProps {
    searchTerm: string;
}

const SearchTermRanks: React.FC<SearchTermRanksProps> = ({ searchTerm }) => {
    const { ranks, isLoading, error } = useSearchTermRanks(searchTerm);

    const navigate = useNavigate();

    const handleRowClick = (rank: Rank) => {
        navigate(`/timetravel/ranks/${rank.id}`);
    };

    return (
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
            <Box sx={{ flex: 1, p: 2, border: 1, borderColor: 'divider', borderRadius: 1 }}>
                <Typography variant="subtitle2" gutterBottom>
                    Search Term Ranks
                </Typography>
                {isLoading ? (
                    <Skeleton variant="rectangular" height={120} />
                ) : error ? (
                    <Typography color="error">Failed to load search term ranks</Typography>
                ) : (
                    <List>
                        {ranks?.map((rank) => (
                            <ListItemButton
                                key={rank.id}
                                onClick={() => handleRowClick(rank)}
                            >
                                <Stack flex={1} direction="row" spacing={2} alignItems="center">
                                    <Avatar variant="rounded" src={rank.listing.product?.image} />
                                    <Typography variant="subtitle2">
                                        {rank.listing.product?.title}
                                    </Typography>

                                </Stack>

                                {rank.wasSponsored && (
                                    <Typography variant="caption" color="text.secondary">
                                        Sponsored
                                    </Typography>
                                )}
                            </ListItemButton>
                        ))}
                    </List>
                )}
            </Box>

            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <Divider orientation="vertical" flexItem />
            </Box>


        </Stack>
    );
};

export default SearchTermRanks;
